/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
export const protobufPackage = "connect";
/** LocationProviderAvailability */
export var Availability;
(function (Availability) {
    Availability["location_on_net"] = "location_on_net";
    Availability["location_near_net"] = "location_near_net";
    Availability["location_off_net"] = "location_off_net";
})(Availability || (Availability = {}));
export var ConnectionChangeStatus_StatusType;
(function (ConnectionChangeStatus_StatusType) {
    ConnectionChangeStatus_StatusType["QUOTES"] = "QUOTES";
    ConnectionChangeStatus_StatusType["CONFIRM_QUOTES"] = "CONFIRM_QUOTES";
    ConnectionChangeStatus_StatusType["CONTRACT_REQUESTED"] = "CONTRACT_REQUESTED";
})(ConnectionChangeStatus_StatusType || (ConnectionChangeStatus_StatusType = {}));
export var ConnectionChangeStatus_StatusCategory;
(function (ConnectionChangeStatus_StatusCategory) {
    ConnectionChangeStatus_StatusCategory["QUOTES_CATEGORY"] = "QUOTES_CATEGORY";
})(ConnectionChangeStatus_StatusCategory || (ConnectionChangeStatus_StatusCategory = {}));
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["unpaid"] = "unpaid";
    InvoiceStatus["paid"] = "paid";
    InvoiceStatus["past_due"] = "past_due";
    InvoiceStatus["cancelled"] = "cancelled";
    InvoiceStatus["upcoming"] = "upcoming";
    InvoiceStatus["refunded"] = "refunded";
})(InvoiceStatus || (InvoiceStatus = {}));
export var QuoteRequest_Status;
(function (QuoteRequest_Status) {
    QuoteRequest_Status["unknown"] = "unknown";
    QuoteRequest_Status["created"] = "created";
    QuoteRequest_Status["ready_for_review"] = "ready_for_review";
    QuoteRequest_Status["contract_requested"] = "contract_requested";
})(QuoteRequest_Status || (QuoteRequest_Status = {}));
export var QuoteRequestUpdateRequest_Status;
(function (QuoteRequestUpdateRequest_Status) {
    QuoteRequestUpdateRequest_Status["unknown"] = "unknown";
    QuoteRequestUpdateRequest_Status["archived"] = "archived";
    QuoteRequestUpdateRequest_Status["contract_requested"] = "contract_requested";
})(QuoteRequestUpdateRequest_Status || (QuoteRequestUpdateRequest_Status = {}));
export var Quote_Status;
(function (Quote_Status) {
    Quote_Status["disabled"] = "disabled";
    Quote_Status["enabled"] = "enabled";
    Quote_Status["proposed"] = "proposed";
    Quote_Status["requested"] = "requested";
})(Quote_Status || (Quote_Status = {}));
export var Quote_RiserResponsibility;
(function (Quote_RiserResponsibility) {
    Quote_RiserResponsibility["provider_responsibility"] = "provider_responsibility";
    Quote_RiserResponsibility["customer_responsibility"] = "customer_responsibility";
    Quote_RiserResponsibility["unknown_responsibility"] = "unknown_responsibility";
})(Quote_RiserResponsibility || (Quote_RiserResponsibility = {}));
export var Quote_Availability;
(function (Quote_Availability) {
    Quote_Availability["unknown"] = "unknown";
    Quote_Availability["location_on_net"] = "location_on_net";
    Quote_Availability["location_near_net"] = "location_near_net";
    Quote_Availability["location_off_net"] = "location_off_net";
})(Quote_Availability || (Quote_Availability = {}));
export var QuotesCreateRequest_Status;
(function (QuotesCreateRequest_Status) {
    QuotesCreateRequest_Status["unknown"] = "unknown";
    QuotesCreateRequest_Status["disabled"] = "disabled";
    QuotesCreateRequest_Status["enabled"] = "enabled";
    QuotesCreateRequest_Status["proposed"] = "proposed";
    QuotesCreateRequest_Status["requested"] = "requested";
})(QuotesCreateRequest_Status || (QuotesCreateRequest_Status = {}));
export var QuotesCreateRequest_RiserResponsibility;
(function (QuotesCreateRequest_RiserResponsibility) {
    QuotesCreateRequest_RiserResponsibility["unknown_responsibility"] = "unknown_responsibility";
    QuotesCreateRequest_RiserResponsibility["provider_responsibility"] = "provider_responsibility";
    QuotesCreateRequest_RiserResponsibility["customer_responsibility"] = "customer_responsibility";
})(QuotesCreateRequest_RiserResponsibility || (QuotesCreateRequest_RiserResponsibility = {}));
export var QuotesUpdateRequest_Status;
(function (QuotesUpdateRequest_Status) {
    QuotesUpdateRequest_Status["unknown"] = "unknown";
    QuotesUpdateRequest_Status["disabled"] = "disabled";
    QuotesUpdateRequest_Status["enabled"] = "enabled";
    QuotesUpdateRequest_Status["proposed"] = "proposed";
    QuotesUpdateRequest_Status["requested"] = "requested";
})(QuotesUpdateRequest_Status || (QuotesUpdateRequest_Status = {}));
export var QuotesUpdateRequest_RiserResponsibility;
(function (QuotesUpdateRequest_RiserResponsibility) {
    QuotesUpdateRequest_RiserResponsibility["unknown_responsibility"] = "unknown_responsibility";
    QuotesUpdateRequest_RiserResponsibility["provider_responsibility"] = "provider_responsibility";
    QuotesUpdateRequest_RiserResponsibility["customer_responsibility"] = "customer_responsibility";
})(QuotesUpdateRequest_RiserResponsibility || (QuotesUpdateRequest_RiserResponsibility = {}));
export var QuoteRequestExport_Status;
(function (QuoteRequestExport_Status) {
    QuoteRequestExport_Status["unknown_status"] = "unknown_status";
    QuoteRequestExport_Status["running"] = "running";
    QuoteRequestExport_Status["success"] = "success";
    QuoteRequestExport_Status["error"] = "error";
})(QuoteRequestExport_Status || (QuoteRequestExport_Status = {}));
export var QuoteRequestExport_Vendor;
(function (QuoteRequestExport_Vendor) {
    QuoteRequestExport_Vendor["unknown_vendor"] = "unknown_vendor";
    QuoteRequestExport_Vendor["telarus"] = "telarus";
    QuoteRequestExport_Vendor["zayo"] = "zayo";
    QuoteRequestExport_Vendor["bandwidth_finder"] = "bandwidth_finder";
    QuoteRequestExport_Vendor["easyquote"] = "easyquote";
})(QuoteRequestExport_Vendor || (QuoteRequestExport_Vendor = {}));
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
